module.exports = __webpack_public_path__ + "img/UI_shouji_saomiao_02_15c600e44.png";